function login({ email, password }) {
  return this.axios.post('/auth/login', { email, password })
}

function logout() {
  return this.axios.post('/auth/logout')
}

function refreshToken() {
  return this.axios.get('/auth/refresh')
}

function restore({ email }) {
  return this.axios.post('/auth/restore', { email })
}

const auth = (axios) => ({ axios, login, logout, refreshToken, restore })

export default auth
